import apiClient from './client';

export const listTickets = (params) => apiClient.get('/tickets', { params }).then((r) => r.data);
export const getTicket = (id) => apiClient.get(`/tickets/${id}`).then((r) => r.data);
export const createTicket = (payload) => apiClient.post('/tickets', payload).then((r) => r.data);
export const updateTicket = (id, payload) => apiClient.put(`/tickets/${id}`, payload).then((r) => r.data);
export const deleteTicket = (id) => apiClient.delete(`/tickets/${id}`).then((r) => r.data);
export const addTicketComment = (id, comment) => apiClient.post(`/tickets/${id}/comments`, { comment }).then((r) => r.data);
export const addTicketAttachment = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/tickets/${id}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
